import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const EditchannelApi = createAsyncThunk(
  "auth/Editchannel",
  async (data, { rejectWithValue }) => {
    console.log(data)
    try {
      const response = await AuthAxios.patch(apiRoutes.channelAction("update",1,data.id,1),data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }

const EditchannelSlice = createSlice({
  name: "Edit channel",
  initialState:intialState,
  reducers: {
    resetchannel: () => intialState,
},
  extraReducers: (builder) => {
    builder.addCase(EditchannelApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(EditchannelApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results;
      state.message = action?.payload?.message;
    });
    builder.addCase(EditchannelApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetchannel } = EditchannelSlice.actions;
export const Editchannelreducer = EditchannelSlice.reducer;
